'use client';

import type { PrV2ReviewResponse } from '@/lib/pr-v2/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { fetchPrV2Reviews } from './fetch-pr-v2';
import { PR_V2_STANDARD_STALE_TIME_MS } from './query-config';
import { prV2ReviewsQueryKey } from './query-keys';

export function prV2ReviewsQueryOptions(owner: string, repo: string, number: string) {
  return queryOptions({
    queryKey: prV2ReviewsQueryKey(owner, repo, number),
    queryFn: ({ signal }) => fetchPrV2Reviews(owner, repo, number, signal),
    staleTime: PR_V2_STANDARD_STALE_TIME_MS,
    refetchOnWindowFocus: false,
  });
}

export function usePrV2Reviews(
  owner: string,
  repo: string,
  number: string,
  options?: {
    enabled?: boolean;
    initialData?: PrV2ReviewResponse[];
  },
) {
  return useQuery({
    ...prV2ReviewsQueryOptions(owner, repo, number),
    enabled: Boolean(owner && repo && number) && (options?.enabled ?? true),
    initialData: options?.initialData,
  });
}
